<app-custom-modal #modal [title]="'Gerenciar acesso ao prontuário do paciente VIP'"
    [subtitle]="'Gerencie quem poderá solicitar acesso ao prontuário deste paciente VIP'" (onCloseClick)="modal.close()"
    [hideCancel]="true" [hideSave]="true">
    <div class="container">
        <div class="row">
            <p>Médicos autorizados</p>
            <div class="input-group">
                <span class="input-group-text">
                    <img src="../../../../assets/img/icons/search.svg" alt="Busca">
                </span>
                <input type="text" [(ngModel)]="nomeMedico" id="txtSearchName" placeholder="Busque por nome ou CPF"
                    (input)="buscarMedico($event)">
            </div>
        </div>

        <div class="row">
            <div class="card mt-4 scroll-container col-12">
                <div *ngFor="let profissional of profissionaisFiltrados">
                    <div class="mt-2" (click)="insertProfissional(profissional)"
                        class="row d-flex align-items-center profissional-container">
                        <div class="col-auto">
                            <div class="user-foto-container">
                                <img src="../../../../../../assets/img/user.png" alt="Foto do usuário">
                            </div>
                        </div>
                        <div class="col-auto d-flex flex-column justify-content-start p-0">
                            <p class="nome-profissional">{{profissional.nome}}</p>
                            <p class="cpf-profissional">{{profissional.cpf | cpfCnpj}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div *ngIf="profissionaisSelecionados.length > 0" class="scroll-container col-12">
                <div class="mt-4" *ngFor="let profissional of profissionaisSelecionados">
                    <div (click)="insertProfissional(profissional)" class="row d-flex align-items-center">
                        <div class="col-auto">
                            <div class="user-foto-container">
                                <img src="../../../../../../assets/img/user.png" alt="Foto do usuário">
                            </div>
                        </div>
                        <div class="col-auto d-flex flex-column justify-content-start p-0">
                            <p class="nome-profissional">{{profissional.nome}}</p>
                            <p class="cpf-profissional">{{profissional.cpf | cpfCnpj}}</p>
                        </div>
                        <div class="col d-flex align-items-center justify-content-end">
                            <button class="btn icon icon-danger" title="Remover do grupo"
                                (click)="removeProfissional(profissional)">
                                <i class="hgi hgi-stroke hgi-delete-02"></i>
                            </button>
                            <button *ngIf="isClinica"
                                [title]="profissional.id == pacienteAcesso.profissionalResponsavelId ? 'Remover acesso como responsável' : 'Definir como responsável'"
                                class="btn btn icon icon-lider ml-3" (click)="setProfissionalResponsavel(profissional)">
                                <i [ngClass]="profissional.id == pacienteAcesso.profissionalResponsavelId ? 'is-lider' : 'default-lider'"
                                    class="hgi hgi-stroke hgi-crown"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <button class="btn primary-white-button mt-4" (click)="save()">
                <span class="button-content">
                    Salvar <i class="hgi hgi-stroke hgi-arrow-right-02"></i>
                </span>
            </button>

            <div class="m-auto">
                <button class="btn btn-danger-no-border mt-4 " (click)="removerStatusVip()">
                    <i class="hgi hgi-stroke hgi-crown mr-2"></i> Remover o status de VIP
                </button>
            </div>
        </div>
    </div>
</app-custom-modal>